import React, { createContext, useContext, useEffect, useState } from "react";
import { customerApi } from "../lib/api";

const CustomerAuthContext = createContext();
export const useCustomerAuth = () => useContext(CustomerAuthContext);

export const CustomerAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    customerApi.get("/customer/me").then((r) => setUser(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const login = () => {
    // Google — REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  const loginGoogle = login;

  const setSession = (data) => {
    if (data.session_token) localStorage.setItem("gv_customer_token", data.session_token);
    setUser(data.user);
  };
  const registerEmail = async (name, email, password) => {
    const { data } = await customerApi.post("/customer/register", { name, email, password });
    setSession(data);
    return data;
  };
  const loginEmail = async (email, password) => {
    const { data } = await customerApi.post("/customer/login", { email, password });
    setSession(data);
    return data;
  };

  const logout = async () => {
    try { await customerApi.post("/customer/logout"); } catch (e) {}
    localStorage.removeItem("gv_customer_token");
    setUser(null);
    window.location.href = "/";
  };

  return (
    <CustomerAuthContext.Provider value={{ user, loading, login, loginGoogle, loginEmail, registerEmail, logout, setUser }}>
      {children}
    </CustomerAuthContext.Provider>
  );
};
